import Prism from "prismjs/components/prism-core";

var tableCell = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/
  .source;
var tableRow = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(
  /__/g,
  function () {
    return tableCell;
  }
);
var tableLine =
  /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;

var inner = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;

/**
 * This function is intended for the creation of the bold or italic pattern.
 *
 * This also adds a lookbehind group to the given pattern to ensure that the pattern is not backslash-escaped.
 *
 * _Note:_ Keep in mind that this adds a capturing group.
 *
 * @param {string} pattern
 * @returns {RegExp}
 */
function createInline(pattern) {
  pattern = pattern.replace(/<inner>/g, function () {
    return inner;
  });
  return RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + pattern + ")");
}

Prism.languages["pshuttle"] = {
  // ...
  parameter: /\[\[[a-z0-9_]+\]\]/,
  // comment: [/\/\/ .*/, /\/\*[\s\S]*?\*\//],
  comment: {
    pattern: /\/\/ .*|\/\*[\s\S]*?(?:\*\/|$)/,
    greedy: true,
  },
  json: {
    // Nested-brace-aware: handles up to 3 levels of {} with string awareness
    pattern: /\{(?:[^{}"\\]|\\.|"(?:[^"\\]|\\.)*"|\{(?:[^{}"\\]|\\.|"(?:[^"\\]|\\.)*"|\{(?:[^{}"\\]|\\.|"(?:[^"\\]|\\.)*")*\})*\})*\}/,
    greedy: true,
    inside: {
      property: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
        lookbehind: true,
        greedy: true,
      },
      string: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
        lookbehind: true,
        greedy: true,
      },
      // comment: {
      //   pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
      //   greedy: true,
      // },
      number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
      punctuation: /[{}[\],]/,
      operator: /:/,
      boolean: /\b(?:false|true)\b/,
      null: {
        pattern: /\bnull\b/,
        alias: "keyword",
      },
    },
  },

  "front-matter-block": {
    pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
    lookbehind: true,
    greedy: true,
    inside: {
      punctuation: /^---|---$/,
      "front-matter": {
        pattern: /\S+(?:\s+\S+)*/,
        alias: ["yaml", "language-yaml"],
      },
    },
  },
  blockquote: {
    // > ...
    pattern: /^>(?:[\t ]*>)*/m,
    alias: "punctuation",
  },
  table: {
    pattern: RegExp("^" + tableRow + tableLine + "(?:" + tableRow + ")*", "m"),
    inside: {
      "table-data-rows": {
        pattern: RegExp(
          "^(" + tableRow + tableLine + ")(?:" + tableRow + ")*$"
        ),
        lookbehind: true,
        inside: {
          "table-data": {
            pattern: RegExp(tableCell),
            inside: Prism.languages.pshuttle,
          },
          punctuation: /\|/,
        },
      },
      "table-line": {
        pattern: RegExp("^(" + tableRow + ")" + tableLine + "$"),
        lookbehind: true,
        inside: {
          punctuation: /\||:?-{3,}:?/,
        },
      },
      "table-header-row": {
        pattern: RegExp("^" + tableRow + "$"),
        inside: {
          "table-header": {
            pattern: RegExp(tableCell),
            alias: "important",
            inside: Prism.languages.pshuttle,
          },
          punctuation: /\|/,
        },
      },
    },
  },
  code: [
    {
      // Prefixed by 4 spaces or 1 tab and preceded by an empty line
      pattern:
        /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
      lookbehind: true,
      alias: "keyword",
    },
    {
      // ```optional language
      // code block
      // ```
      pattern: /^```[\s\S]*?^```$/m,
      greedy: true,
      inside: {
        "code-block": {
          pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
          lookbehind: true,
        },
        "code-language": {
          pattern: /^(```).+/,
          lookbehind: true,
        },
        punctuation: /```/,
      },
    },
  ],
  title: [
    {
      // title 1
      // =======

      // title 2
      // -------
      pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
      alias: "important",
      inside: {
        punctuation: /==+$|--+$/,
      },
    },
    {
      // # title 1
      // ###### title 6
      pattern: /(^\s*)#.+/m,
      lookbehind: true,
      alias: "important",
      inside: {
        punctuation: /^#+|#+$/,
      },
    },
  ],
  hr: {
    // ***
    // ---
    // * * *
    // -----------
    pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
    lookbehind: true,
    alias: "punctuation",
  },
  list: {
    // * item
    // + item
    // - item
    // 1. item
    pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
    lookbehind: true,
    alias: "punctuation",
  },
  "url-reference": {
    // [id]: http://example.com "Optional title"
    // [id]: http://example.com 'Optional title'
    // [id]: http://example.com (Optional title)
    // [id]: <http://example.com> "Optional title"
    pattern:
      /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
    inside: {
      variable: {
        pattern: /^(!?\[)[^\]]+/,
        lookbehind: true,
      },
      string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
      punctuation: /^[[\]!:]|[<>]/,
    },
    alias: "url",
  },
  bold: {
    // **strong**
    // __strong__

    // allow one nested instance of italic text using the same delimiter
    pattern: createInline(
      /\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/
        .source
    ),
    lookbehind: true,
    greedy: true,
    inside: {
      content: {
        pattern: /(^..)[\s\S]+(?=..$)/,
        lookbehind: true,
        inside: {}, // see below
      },
      punctuation: /\*\*|__/,
    },
  },
  italic: {
    // *em*
    // _em_

    // allow one nested instance of bold text using the same delimiter
    pattern: createInline(
      /\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/
        .source
    ),
    lookbehind: true,
    greedy: true,
    inside: {
      content: {
        pattern: /(^.)[\s\S]+(?=.$)/,
        lookbehind: true,
        inside: {}, // see below
      },
      punctuation: /[*_]/,
    },
  },
  strike: {
    // ~~strike through~~
    // ~strike~
    pattern: createInline(/(~~?)(?:(?!~)<inner>)+\2/.source),
    lookbehind: true,
    greedy: true,
    inside: {
      content: {
        pattern: /(^~~?)[\s\S]+(?=\1$)/,
        lookbehind: true,
        inside: {}, // see below
      },
      punctuation: /~~?/,
    },
  },
  "code-snippet": {
    // `code`
    // ``code``
    pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
    lookbehind: true,
    greedy: true,
    alias: ["code", "keyword"],
  },
  url: {
    // [example](http://example.com "Optional title")
    // [example][id]
    // [example] [id]
    pattern: createInline(
      /!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/
        .source
    ),
    lookbehind: true,
    greedy: true,
    inside: {
      operator: /^!/,
      content: {
        pattern: /(^\[)[^\]]+(?=\])/,
        lookbehind: true,
        inside: {}, // see below
      },
      variable: {
        pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
        lookbehind: true,
      },
      url: {
        pattern: /(^\]\()[^\s)]+/,
        lookbehind: true,
      },
      string: {
        pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
        lookbehind: true,
      },
    },
  },
};

["url", "bold", "italic", "strike"].forEach(function (token) {
  ["url", "bold", "italic", "strike", "code-snippet"].forEach(function (inside) {
    if (token !== inside) {
      Prism.languages.pshuttle[token].inside.content.inside[inside] =
        Prism.languages.pshuttle[inside];
    }
  });
});
